module.exports = __webpack_public_path__ + "img/29.340127ef.webp";